/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import Vue from 'vue'
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_baseUrl
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// Ensure the Authorization header is always present from localStorage on every
// request. This is critical on iOS Safari (PWA) where axios.defaults may not be
// reliably set before the first API call fires.
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Token ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

const config = {
  baseURL: process.env.VUE_APP_baseUrl,
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  reqConfig => {
    const token = localStorage.getItem('token')
    if (token) {
      reqConfig.headers = reqConfig.headers || {}
      reqConfig.headers.Authorization = `Token ${token}`
    }
    return reqConfig
  },
  error => Promise.reject(error),
)

_axios.interceptors.response.use(
  response => response,
  error => Promise.reject(error),
)

const Plugin = {
  install(Vue) {
    Vue.axios = _axios
    window.axios = _axios
    Object.defineProperties(Vue.prototype, {
      axios: {
        get() {
          return _axios
        },
      },
      $axios: {
        get() {
          return _axios
        },
      },
    })
  },
}

Vue.use(Plugin)

export default Plugin
